// extracted by mini-css-extract-plugin
module.exports = {"address":"Authentication_address__2vUA7","button":"Authentication_button__1BBSP","warning":"Authentication_warning__ZhLv9"};